import axios from "axios";
import APP_CONFIG from "../app/configuration/AppConfig";
import { IMultiSiteConfigurationSummary } from "./MultiSiteConfigurationModels";

export const getMultiSiteConfigurationSummary = async (
  siteIds: string[],
  signal?: AbortSignal
): Promise<IMultiSiteConfigurationSummary> => {
  const url = `${APP_CONFIG.serviceUrls.apiHostUrl}/siteAppConfigs/multisite/configuration-summary`;
  const response = await axios.post<IMultiSiteConfigurationSummary>(url, { siteIds }, { signal });
  return response.data;
};
